<template>
  <Popup
    v-if="dropdown"
    class="search-page__popup-sort"
    position="absolute"
    :teleport="false"
    transition="slide-up"
    :show="show"
    @update:show="$emit('update:show', $event)"
  >
    <div class="sort__options">
      <div
        class="sort__option"
        :class="{
          'sort__option--active': selectedOptionIndex == index,
        }"
        v-for="(option, index) of sortOptions"
        :key="index"
        @click="sort(option)"
      >
        {{ option.title }}
      </div>
    </div>
  </Popup>
  <Popup
    v-else
    class="sort-popup"
    width="semi-full"
    position="fixed"
    transition="slide-left"
    :show="show"
    @update:show="$emit('update:show', $event)"
  >
    <h2 class="sort-popup__header">
      <div class="icon-wrapper" @click="$emit('update:show', false)">
        <ArrowLeft />
      </div>
      <span>Sort</span>
    </h2>
    <div class="sort-popup__body">
      <div class="sort__options">
        <div
          class="sort__option"
          :class="{
            'sort__option--active': selectedOptionIndex == index,
          }"
          v-for="(option, index) of sortOptions"
          :key="index"
          @click="sort(option)"
        >
          <input
            class="radio-sort-by"
            type="radio"
            checked
            :class="{
              'radio-sort-by--active': selectedOptionIndex == index,
            }"
          />
          {{ option.title }}
        </div>
      </div>
    </div>
    <div class="filter-popup__footer">
      <sib-button role="primary" @click="emit('update:show', false)">
        Apply
      </sib-button>
    </div>
  </Popup>
</template>

<script lang="ts" setup>
import { SortOption } from '@/types'
import Popup from '@/ui-kits/Popup.vue'
import ArrowLeft from '@/assets/images/icons/arrow-left.svg'

const props = withDefaults(
  defineProps<{
    show: boolean
    sortOptions: SortOption[]
    selectedOptionIndex: number
    dropdown?: boolean
  }>(),
  {
    show: false,
    sortOptions: () => [],
    selectedOptionIndex: 0,
    dropdown: true,
  }
)

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
  (e: 'input', value: string): void
}>()

function sort(option: SortOption) {
  if (props.dropdown) emit('update:show', false)
  emit('input', option.value)
}
</script>

<style lang="scss">
.search-page {
  &__popup-sort {
    height: auto;
    top: 100%;

    .popup {
      &__content {
        height: auto;
      }

      &__backdrop {
        height: 100vh;
      }
    }

    .sort {
      &__option {
        text-align: center;
        padding: 0.8em 0;
        border-bottom: solid 1px var(--border-color);

        &:last-child {
          border-bottom: none;
        }

        &--active {
          color: var(--color-primary);
        }
      }
    }
  }
}

.sort-popup {
  --filer-popup-header-height: 3.5rem;
  --filer-popup-footer-height: 4rem;

  .sort {
    &__option {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      cursor: pointer;
      padding: 0.8em 0;
      border-bottom: solid 1px var(--border-color);

      &:last-child {
        border-bottom: none;
      }

      &--active {
        color: var(--color-primary);
      }
    }
  }

  .radio-sort-by {
    appearance: none;
    border: 1px solid var(--border-color);
    border-radius: 100%;
    contain: paint;
    cursor: pointer;
    flex: 0 0 18px;
    height: 18px;
    position: relative;
    width: 18px;
    &--active {
      &::before {
        background-color: var(--color-primary);
        border-radius: 100%;
        content: '';
        inset: 2px;
        position: absolute;
      }
    }
  }

  .popup__content {
    overflow: auto;
    padding: 0 1em;
    max-width: 80%;
  }

  &__header {
    font-size: 1.2em;
    display: flex;
    align-items: center;
    border-bottom: solid 1px var(--border-color);
    margin: 0;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--filer-popup-header-height);
    background-color: #fff;
    z-index: 1;

    span {
      width: 100%;
      text-align: center;
    }

    svg {
      width: 1em;
      height: 1em;
    }
  }

  &__body {
    padding: 0.5em 0 5em;
    min-height: 80%;
  }
}
</style>
